import VueLazyload from 'vue-lazyload';
import { vMaska } from 'maska';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueLazyload, {
    attempt: 2,
    preLoad: 1.5,
    observer: true,
    lazyComponent: true
  });
  nuxtApp.vueApp.directive('maska', vMaska);
});
